import * as React from "react";
import { Badge } from "@/core/components/ui/badge";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface SelfSignupBadgeProps {
  className?: string;
}

export const SelfSignupBadge: React.FC<SelfSignupBadgeProps> = ({
  className,
}) => (
  <Badge variant="gray" className={cn("gap-2", className)}>
    <Typography variant="captionW1">Self sign-up</Typography>
  </Badge>
);

SelfSignupBadge.displayName = "SelfSignupBadge";
